module.exports = {
  "id": "shedding",
  "title": "shedding",
  "image": "provision/parts/shedding/shedding.png",
  "info": [
    {
      "text": "Add shedding to your project",
      "image": "provision/parts/shedding/shedding.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/shedding/shedding.png"
} ;